var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentBankOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M9.6 1.37a2 2 0 0 1 2.8 0l1.267 1.242a2 2 0 0 0 1.379.571l1.773.018a2 2 0 0 1 1.98 1.98l.018 1.774a2 2 0 0 0 .571 1.378l1.241 1.268a2 2 0 0 1 0 2.798l-1.241 1.268a2 2 0 0 0-.571 1.379l-.018 1.773a2 2 0 0 1-1.98 1.98l-1.773.018a2 2 0 0 0-1.38.571L12.4 20.629a2 2 0 0 1-2.798 0l-1.268-1.241a2 2 0 0 0-1.378-.571l-1.774-.018a2 2 0 0 1-1.98-1.98l-.018-1.773a2 2 0 0 0-.571-1.38L1.371 12.4a2 2 0 0 1 0-2.798l1.241-1.268a2 2 0 0 0 .571-1.378l.018-1.774a2 2 0 0 1 1.98-1.98l1.774-.018a2 2 0 0 0 1.378-.571l1.268-1.241Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.733 12.941 4.963-4.728a.791.791 0 0 1 1.08 0 .704.704 0 0 1 0 1.03L9.733 15l-3.51-3.344a.704.704 0 0 1 0-1.03.79.79 0 0 1 1.081 0l2.43 2.316Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentBankOk);
export default __webpack_public_path__ + "static/media/sentBankOk.0e5bcbb9ab804cd48b9b4929a2dd6775.svg";
export { ForwardRef as ReactComponent };